import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import HomePage from '../pages/homepage';
import About from '../pages/about';
import Contact from '../pages/contact';
import Product from '../pages/product';
import News from '../pages/news';
import NewsDetail from '../pages/newsDetail';
import ProductDetail from '../pages/productDetail';

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path={['/', '/:lang']} component={HomePage} />
        <Route exact path='/:lang/about' component={About} />
        <Route exact path='/:lang/contact' component={Contact} />
        <Route exact path='/:lang/product' component={Product} />
        <Route exact path='/:lang/news' component={News} />
        <Route exact path='/:lang/news/:id' component={NewsDetail} />
        <Route exact path='/:lang/product/:id' component={ProductDetail} />
      </Switch>
    </Router>
  );
};

export default Routes;
